import React from "react";
import Navbar from "./components/pages/Home.js";
import Footer from "./components/pages/footer.js";
import { SpeedInsights } from '@vercel/speed-insights/react';
import ReactPageScroller from 'react-page-scroller';
import FullPageScroll from "./components/FullPageScroll.js";

function App() {
  return (
    <div>
      <SpeedInsights />
      <FullPageScroll/>
    </div>
  );
}

export default App;
